import React from 'react';
import './MyBlog.css'
import NavbarHeader from '../Navbarheader/NavbarHeader';
import BuildProject from '../buildProject/BuildProject';
import Footer from '../Footer/Footer';



function MyBlog() {
    return (
        <div fluid style={{ height: 100 + "vh" }} className="scroll-container">
        <div  className="BlogPage">
            <NavbarHeader />
            <BuildProject />
           
        </div>
         <Footer />
         </div>
    );
}

export default MyBlog;
